<template>
    <div class="container">
        <div class="nav-left">
            <div :class="['tab-item',{active:currentTab==='production' || currentTab==='productionInfo'}]" @click="toRoute('production')">产品</div>
            <div :class="['tab-item',{active:currentTab==='device' || currentTab==='deviceInfo' || currentTab==='deviceDetail'}]" @click="toRoute('device')">设备</div>
        </div>
        <div class="right-container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'sideBar',
        computed: {
            currentTab () {
                const temp = this.$route.path.split('/')
                return temp[temp.length - 1];
            }
        },
        methods: {
            toRoute (value) {
                if (this.currentTab === value) {
                    return
                }
                if (value === 'device' || value === 'production') {
                    this.$router.push(`/main/${value}`)
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .container{
      display: flex;
      height: 100%;
      width: 100%;
      overflow-x: auto;
    }
    .nav-left{
        width: 200px;
        height: calc(100% - 19px);
        padding-top: 19px;
        background-color: #FCFCFC;
        border-right: 1px solid #E1E1E1;
        color: #606161;
        font-size: 14px;
        font-weight: 500;
        .header{
            height: 40px;
            padding-left: 20px;
            display: flex;
            align-items: center;
        }
        .tab-item{
            height: 40px;
            padding-left: 14px;
            display: flex;
            align-items: center;
            cursor: pointer;
            color: #2E2E2E;
            font-weight: 500;
            border-left: 4px solid transparent;
            &.active{
                background-color: #EDEFF3;
                border-left: 4px solid #3389FF;
            }
        }
    }
    .right-container{
        flex-grow: 1;
        padding: 2px 20px 0 23px;
        background-color: #fff;
        width: calc(100% - 244px);
    }
</style>